import { useEffect, useState } from 'react';

import { getVoiceRecording } from './recordingApi';

export const UNAVAILABLE_RECORDING_MESSAGE =
  'The audio file is not available for this conversation.';

const COMPLIANCE_RECORDING_MESSAGE =
  'Due to compliance and security requirements, the audio file will be available for only 30 days.';

export const useFetchConversationVoiceRecording = (conversationId: string) => {
  const [isLoadingConversationRecording, setIsLoadingConversationRecording] =
    useState(true);
  const [audioBlob, setAudioBlob] = useState<Blob | null>(null);

  const alertMessage = audioBlob
    ? COMPLIANCE_RECORDING_MESSAGE
    : UNAVAILABLE_RECORDING_MESSAGE;

  useEffect(() => {
    const fetchVoiceRecordingUrl = async () => {
      try {
        const response = await getVoiceRecording({
          conversation_id: conversationId,
        });
        const blob = await response.blob();

        setAudioBlob(blob);
      } catch (error) {
        setAudioBlob(null);
      } finally {
        setIsLoadingConversationRecording(false);
      }
    };

    fetchVoiceRecordingUrl();
  }, [conversationId]);

  return {
    alertMessage,
    audioBlob,
    isLoadingConversationRecording,
  };
};
